import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_green-properties-crt/artifacts/4twghzfk_LOGO%20GREEHOUSE-def.pdf%20%282%29.png";

export default function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const trimmedEmail = email.trim().toLowerCase();
    const trimmedPassword = password.trim();

    if (!trimmedEmail || !trimmedPassword) {
      setError('Inserisci email e password');
      setLoading(false);
      return;
    }

    try {
      await login(trimmedEmail, trimmedPassword);
      toast.success('Login effettuato con successo');
      navigate('/admin/dashboard');
    } catch (err) {
      let errorMsg;
      if (err.response) {
        // Server responded with error
        const status = err.response.status;
        const detail = err.response.data?.detail;
        if (status === 401) {
          errorMsg = "Email o password non corretti.";
        } else if (status === 422) {
          errorMsg = "Formato email non valido. Controlla i dati inseriti.";
        } else if (detail && typeof detail === 'string') {
          errorMsg = detail;
        } else {
          errorMsg = `Errore dal server (${status}). Riprova.`;
        }
      } else if (err.request) {
        errorMsg = "Impossibile contattare il server. Verifica la connessione internet e riprova.";
      } else {
        errorMsg = err.message || "Errore imprevisto. Riprova.";
      }
      setError(errorMsg);
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Green House" className="h-16 mx-auto mb-6" />
          <h1 className="font-serif text-3xl text-text-main">Area Riservata</h1>
          <p className="font-sans text-text-muted mt-2">Accedi per gestire gli annunci</p>
        </div>

        <div className="bg-white p-8 rounded-xl shadow-lg">
          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <div className="p-3 bg-red-50 text-red-600 rounded-md text-sm font-sans" data-testid="login-error">
                {error}
              </div>
            )}
            <div>
              <label className="block font-sans text-sm text-text-main mb-2">Email</label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@greenhouse.it"
                required
                data-testid="login-email"
              />
            </div>
            <div>
              <label className="block font-sans text-sm text-text-main mb-2">Password</label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password"
              />
            </div>
            <Button
              type="submit"
              className="w-full bg-primary hover:bg-primary-hover"
              disabled={loading}
              data-testid="login-submit"
            >
              {loading ? 'Accesso in corso...' : 'Accedi'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
